import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function LegalDoc({ docKey }) {
  const { t } = useI18n();
  const { lang } = useParams();
  const sections = t(`${docKey}.sections`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [docKey]);

  return (
    <article className="bg-sand pt-[72px]">
      <div className="border-b border-ink/10 bg-white">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 py-14 lg:py-20">
          <Link
            to={`/${lang}`}
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-terracotta hover:gap-3 transition-all"
          >
            <ArrowLeft size={14} />
            {t("legalCommon.backHome")}
          </Link>
          <h1 className="mt-6 font-heading text-3xl sm:text-5xl font-extrabold tracking-tight text-ink">
            {t(`${docKey}.title`)}
          </h1>
          <p className="mt-3 font-mono text-xs uppercase tracking-widest text-mineral">
            {t("legalCommon.updated")}
          </p>
          <p className="mt-6 text-base leading-relaxed text-mineral">{t(`${docKey}.intro`)}</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-14 lg:py-20">
        <div className="space-y-12">
          {Array.isArray(sections) &&
            sections.map((s, i) => (
              <motion.section
                key={i}
                data-testid={`legal-section-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              >
                <h2 className="font-heading text-xl sm:text-2xl font-bold text-ink">{s.h}</h2>
                <div className="mt-4 space-y-4">
                  {s.p.map((para, j) => (
                    <p key={j} className="text-[15px] leading-relaxed text-mineral">
                      {para}
                    </p>
                  ))}
                </div>
              </motion.section>
            ))}
        </div>

        <div className="mt-16 border-t border-ink/10 pt-8">
          <Link
            to={`/${lang}`}
            data-testid="legal-back-home-bottom"
            className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-3 text-sm font-semibold text-white hover:bg-terracotta transition-colors"
          >
            <ArrowLeft size={16} />
            {t("legalCommon.backHome")}
          </Link>
        </div>
      </div>
    </article>
  );
}
